module.exports = __webpack_public_path__ + "a8785ad8b5d33cadbfc55bd28f665481.pdf";